export const getColors = ({ colors, color, metric }) => {
  return {
    main: color || metric.color,
    overlay: 'white',
    ...colors
  };
};
